<ion-header>
  <ion-toolbar color="primary">
    <ion-title>{{'ENTERPRISE_SELECTION.REQUEST_TEST_ACCOUNT'|translate}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content scrollY="true">
  <div class="ion-padding">
    <ion-row class="ion-justify-content-center">
      <h6 class="ion-text">Please fill out the following fields</h6>
    </ion-row>
    <form [formGroup]="formGroup">
      <ion-item>
        <ion-label position="floating">{{'Name'|translate}}</ion-label>
        <ion-input formControlName="name" aria-label="Name"></ion-input>
      </ion-item>
      <app-validation-error [formGroup]="formGroup" [validationMessages]="validationMessages" [controlName]="'name'">
      </app-validation-error>
      <ion-item>
        <ion-label position="floating">{{'LASTNAME'|translate}}</ion-label>
        <ion-input formControlName="nachname" aria-label="Nachname"></ion-input>
      </ion-item>
      <app-validation-error [formGroup]="formGroup" [validationMessages]="validationMessages" [controlName]="'nachname'">
      </app-validation-error>
      <ion-item>
        <ion-label position="floating">{{'EMAIL'|translate}}</ion-label>
        <ion-input formControlName="email" aria-label="Email"></ion-input>
      </ion-item>
      <app-validation-error [formGroup]="formGroup" [validationMessages]="validationMessages" [controlName]="'email'">
      </app-validation-error>
      <ion-item>
        <ion-label position="floating">{{'PHONE'|translate}}</ion-label>
        <ion-input formControlName="telefon" aria-label="Telefon"></ion-input>
      </ion-item>
      <app-validation-error [formGroup]="formGroup" [validationMessages]="validationMessages" [controlName]="'telefon'">
      </app-validation-error>
      <ion-item>
        <ion-label position="floating">{{'ENTERPRISE.NAME'|translate}}</ion-label>
        <ion-input formControlName="enterpriseName" aria-label="Enterprise Name"></ion-input>
      </ion-item>
      <app-validation-error [formGroup]="formGroup" [validationMessages]="validationMessages" [controlName]="'enterpriseName'">
      </app-validation-error>
    </form>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <!-- <ion-title>Solid Buttons</ion-title> -->
    <ion-buttons slot="primary">
      <ion-button fill="outline" color="primary" (click)="onClickCancel()">
        {{'CANCEL'|translate}}
        <!-- <ion-icon slot="end" name="help-circle"></ion-icon> -->
      </ion-button>
      <ion-button fill="outline" color="secondary" (click)="onClickOk()" [disabled]="!(formGroup.touched && formGroup.valid)">
        {{'ENTERPRISE_SELECTION.REQUEST_TEST_ACCOUNT'|translate}}
        <!-- <ion-icon slot="end" name="help-circle"></ion-icon> -->
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
